import Timeline from './timeline';
import TimelineItem from './timeline-item';

Timeline.TimelineItem = TimelineItem;

export default Timeline;
